import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { fromEvent, map, takeUntil } from 'rxjs';
import { MatFormFieldControlImpl } from '../../ng-material-impl/mat-form-field-control.impl';
import { PhoneFormControlService } from '../phone-form-control.service';

@Component({
  selector: 'ss-phone-control',
  templateUrl: './phone-control.component.html',
  styleUrls: ['./phone-control.component.css'],
  providers: [
    {
      provide: MatFormFieldControl,
      useExisting: PhoneControlComponent
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhoneControlComponent extends MatFormFieldControlImpl<string> implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('inputRef')
  private _inputRef!: ElementRef<HTMLInputElement>

  // @ViewChild(PhoneCountrySelectComponent)
  // private _phoneCountrySelect!: PhoneCountrySelectComponent

  readonly phoneNumberSubject = this._phoneFormControlService.phoneNumberSubject;
  readonly valueSubject = this._formControlService.valueSubject;

  constructor(
    private _phoneFormControlService: PhoneFormControlService,
  ) {

    super('phone')

  }

  ngOnInit(): void {

    this.valueSubject
      .pipe(takeUntil(this._destroy))
      .subscribe((value) => {
        this.value = value;
      })
  }

  ngAfterViewInit() {

    fromEvent(this._inputRef.nativeElement, 'keyup')
      .pipe(
        takeUntil(this._destroy),
        map((evParams) => {
          const target = evParams.target as HTMLInputElement
          const value = target.value;

          return value;
        })
      )
      .subscribe((value) => {
        this.phoneNumberSubject.next(value)
      })


  }

  onContainerClick(event: MouseEvent): void {
    const [prefix] = this.value?.split('-') || []

    if (!prefix) {
      // this._phoneCountrySelect.focus()
      return;
    }

    this._inputRef.nativeElement.focus();
  }

  ngOnDestroy() {

    this._destroy.next();
    this._destroy.complete();
  }

}
